import { createReducer } from '@api/createRequestStore';
import update from 'immutability-helper';
import * as types from './types';

function createNamedWrapperReducer(reducerFunction) {
  return (state, action) => {
    const { type } = action;
    let newState = state;
    if (type === types.REMOVE_RANGE_DATA) {
      const { index } = action;
      newState = update(state, {
        payload: { $splice: [[index, 1]] },
        response: { $splice: [[index, 1]] },
      });
    }
    return reducerFunction(newState, action);
  };
}

export default createNamedWrapperReducer(createReducer(types.SCOPE));
